module.exports = __webpack_public_path__ + "static/media/presentation.df28f5a2.png";